import { render, staticRenderFns } from "./ResourceFormCreate.vue?vue&type=template&id=4fa91c7c&scoped=true"
import script from "./ResourceFormCreate.vue?vue&type=script&lang=ts"
export * from "./ResourceFormCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa91c7c",
  null
  
)

export default component.exports